import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import { theme } from "../../../../utils/global-styles/theme";

import SyllabusAccordion from "./child-components/SyllabusAccordion";

const CourseSyllabus = ({
  courseSyllabus,
  downloadButton,
  enrollButton,
  courseSyllabusHeader,
  showNumbersAndBullets = true,
}) => {
  const CourseSyllabusGrid = styled.div`
      height: max-content;
      display: grid;
      grid-template-rows: 10px 1fr 120px;
      grid-template-columns: 80px 1fr 120px;
      font-family: ${theme.fontFaces.headers};

      @media only screen and (max-width: ${theme.breakpoints.helper1350}) {
        grid-template-columns: 10px 1fr 120px;
      }

      @media only screen and (max-width: ${theme.breakpoints.helper1100}) {
        grid-template-columns: 10px 1fr 120px;
      }

      @media only screen and (max-width: ${theme.breakpoints.helper800}) {
        grid-template-rows: 50px 1fr 50px;
        grid-template-columns: 0px 1fr 0px;
      }
    `,
    SyllabusTitleContainer = styled.div`
      grid-area: 2 / 2 / span 1 / span 1;
      @media only screen and (max-width: ${theme.breakpoints.helper800}) {
        margin-left: 0;
      }
    `,
    SyllabusTitle = styled.h2`
      font-size: 35px;
      font-weight: bold;
      letter-spacing: -0.91px;
      line-height: 42px;
      padding-bottom: 50px;
      border-bottom: 1px solid ${theme.colors.accent};

      @media only screen and (max-width: ${theme.breakpoints.helper800}) {
        padding-left: 40px;
        padding-bottom: 20px;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: -0.52px;
        line-height: 24px;
      }
    `;

  return (
    <CourseSyllabusGrid>
      <SyllabusTitleContainer>
        <SyllabusTitle>
          {courseSyllabusHeader || "Course Syllabus"}
        </SyllabusTitle>
        {courseSyllabus.map((section, index) => {
          return (
            <SyllabusAccordion
              key={index}
              index={index}
              title={section?.title}
              description={section?.description?.description}
              numbersAndBullets={showNumbersAndBullets}
            />
          );
        })}
        {downloadButton ? downloadButton : null}
        {enrollButton ? enrollButton : null}
      </SyllabusTitleContainer>
    </CourseSyllabusGrid>
  );
};

CourseSyllabus.propTypes = {
  courseSyllabus: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.shape({
        description: PropTypes.string,
      }),
    })
  ),
  downloadButton: PropTypes.node,
  enrollButton: PropTypes.node,
};

export default CourseSyllabus;
